export default __webpack_public_path__ + "static/media/logo.78c5512e.svg";